import React, { useEffect, useState } from 'react';
import { Card, Container, Form, Image, Button, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Dispatch, RootState, useAppDispatch } from '../../../store';
import { getToken, setToken } from '../../../shared/utils/utils';
import { useFormik } from 'formik';
import { LoginValidationSchema } from '../../../shared/validationSchema';
import { useSelector } from 'react-redux';
import { login } from '../auth.service';
// import { decrypt, encrypt } from 'n-krypta';

const Login = () => {
	const [showPassword, setShowPassword] = useState(false);
	const isLoggedin = useSelector((state: RootState) => state.auth.isLoggedin);
	const isLoading = useSelector((state: RootState) => state.auth.isLoading);
	const navigate = useNavigate();
	const dispatch: Dispatch = useAppDispatch();

	const remember = getToken('remember_me') || false;
	const [ischecked, setChecked] = useState(Boolean(remember));
	// const token = getToken('Password') || '';

	// const decreptPass = decrypt(token, process.env.REACT_APP_DECREPT_KEY as string);
	// const [pass, setPass] = useState<string>((decreptPass && decreptPass) || '');

	const formik = useFormik({
		initialValues: {
			email: (getToken('email') as string) || '',
			password: ''
		},
		validationSchema: LoginValidationSchema,
		onSubmit: async values => {
			if (ischecked) {
				setToken('email', values.email);
				setToken('remember_me', JSON.stringify('true'));
				// const encryptedPassword = await encrypt(
				// 	values.password,
				// 	process.env.REACT_APP_DECREPT_KEY as string
				// );
				// console.log(encryptedPassword);

				// setToken('Password', encryptedPassword);
			} else {
				localStorage.removeItem('email');
				// localStorage.removeItem('Password');
				localStorage.removeItem('remember_me');
			}
			// const userData = { ...values, userType: 2 };
			const userData = { ...values };
			dispatch(login(userData));
		}
	});

	useEffect(() => {
		if (isLoggedin) {
			navigate('/dashboard');
		}
	}, [isLoggedin]);

	const { values, handleChange, handleBlur, touched, errors } = formik;

	return (
		<div className='content-wrapper pt-0'>
			<div className='d-flex flex-column justify-content-center text-center min-h-100vh'>
				<Container>
					<Form onSubmit={formik.handleSubmit}>
						<Card className='auth-box'>
							<Card.Body>
								<div className='mb-3 mb-lg-4'>
									<Image
										src='/assets/images/header-logo-v2.svg'
										className='login-logo'
										alt='Logo'
									/>
								</div>
								<h1 className='h4 mb-3'>Sign In</h1>
								<p className='mb-4'>Enter your credentials to access the panel</p>
								<Form.Group className='text-start mb-3 mb-lg-4' controlId='formEmail'>
									<Form.Control
										type='email'
										size='lg'
										placeholder='Email'
										name='email'
										value={values.email}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									{errors.email && touched.email && (
										<Form.Text className='text-danger'>
											{errors.email as string}
										</Form.Text>
									)}
								</Form.Group>
								<Form.Group className='text-start mb-3 mb-lg-4' controlId='formPassword'>
									<div className='position-relative'>
										<Form.Control
											type={showPassword ? 'text' : 'password'}
											size='lg'
											placeholder='Password'
											name='password'
											value={values.password}
											onChange={handleChange}
											onBlur={handleBlur}
											style={{ paddingRight: '2rem' }}
										/>
										<Button
											variant='link'
											type='button'
											className='position-absolute top-50 end-10 translate-middle-y p-0'
											style={{ right: '10px', zIndex: 2 }}
											tabIndex={-1}
											onClick={() => setShowPassword(prev => !prev)}
										>
											{showPassword ? (
												<Image
													src='/assets/images/eye-svgrepo-com.svg'
													className='login-logo'
													alt='Logo'
													height={22}
													width={22}
												/>
											) : (
												<Image
													src='/assets/images/eye-slash-svgrepo-com.svg'
													className='login-logo'
													alt='Logo'
													height={22}
													width={22}
												/>
											)}
										</Button>
									</div>
									{errors.password && touched.password && (
										<Form.Text className='text-danger'>{errors.password}</Form.Text>
									)}
								</Form.Group>
								<Button
									variant='primary'
									size='lg'
									className='w-100 mb-3 mb-lg-4'
									type='submit'
									disabled={isLoading}
								>
									<span className='mr-10'>Sign In</span>
									{isLoading && (
										<Spinner
											size='sm'
											animation='border'
											role='status'
											className='ms-2'
										></Spinner>
									)}
								</Button>
								<div className='d-flex align-items-center justify-content-between font-size-14'>
									<Form.Check
										label='Remember me'
										name='remember-password'
										type='checkbox'
										id={`remember-password`}
										checked={ischecked}
										onChange={() => setChecked(!ischecked)}
									/>
									<Link to='/forgot-password'>Forgot Password?</Link>
								</div>
							</Card.Body>
						</Card>
					</Form>
				</Container>
			</div>
		</div>
	);
};

export default Login;
